var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default-view',[_c('v-row',{staticClass:"fill-height mx-n3 mt-n2",attrs:{"align":"start","no-gutters":"","justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('onglet-carto')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }